import { render, staticRenderFns } from "./modal-different-dates.vue?vue&type=template&id=fa8059ca&scoped=true"
import script from "./modal-different-dates.vue?vue&type=script&lang=ts"
export * from "./modal-different-dates.vue?vue&type=script&lang=ts"
import style0 from "./modal-different-dates.vue?vue&type=style&index=0&id=fa8059ca&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8059ca",
  null
  
)

export default component.exports